import { useState } from "react";
import { ERROR_UNEXPECTED, WRONG_IDS } from "../constants/feedbacks";
import { useFeedback } from "../Contexts/FeedbackContext";
import { useNavigate } from "react-router-dom";
import { login } from "../services/loginService";
import { TOKEN_KEY } from "../constants/storageKey";

export function useLoginPage() {
  const [id, setId] = useState({ username: "", password: "" });
  const { showFeedback } = useFeedback();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    login(id)
      .then((res) => {
        localStorage.setItem(TOKEN_KEY, res.data.token);
        navigate("/log");
      })
      .catch((e) => {
        if (e.status === 401) {
          showFeedback(WRONG_IDS, false);
        } else {
          showFeedback(ERROR_UNEXPECTED, false);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { handleSubmit, loading, id, setId };
}
